import script from "./PageFooters.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageFooters.vue?vue&type=script&setup=true&lang=ts"

import "./PageFooters.vue?vue&type=style&index=0&id=306466e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-306466e7"]])

export default __exports__